import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, map, Observable, of, startWith, throwError } from 'rxjs';
interface APIState<T> {
  loading: boolean,
  error: string | null,
  data: T | null,
}

@Injectable({
  providedIn: 'root'
})
export class Buyer {
    private http = inject(HttpClient);

    createOrder(orderData:any){
      return this.http.post<any>(`${environment.apiUrl}/order`,orderData)
    .pipe(catchError(this.errorHandle));
    }

    getOrderList(rowNum:any,size:any,orderStatus:any,sortKey:any,sortOrder:any){
      return this.http.get<any>(`${environment.apiUrl}/order/list?rowNum=${rowNum}&size=${size}&orderStatus=${orderStatus}&sortKey=${sortKey}&sortOrder=${sortOrder}`)
      .pipe(catchError(this.errorHandle));
    }


    getBuyerCatalog(sellerId:any,rowNum:number,size:number,status:any,searchKey:any,searchText:any,topPick:any){
      return this.http.get<any>(`${environment.apiUrl}/catalog/article?rowNum=${rowNum}&size=${size}&status=${status}&searchKey=${searchKey}&searchText=${searchText}&topPick=${topPick}`)
      .pipe(catchError(this.errorHandle));
    }

    updateOrder(orderId:any,updateForm:any){
      return this.http.patch<any>(`${environment.apiUrl}/order/${orderId}`,updateForm)
      .pipe(catchError(this.errorHandle));
    }

    assignOrder(orderId:any,updateForm:any){
      return this.http.patch<any>(`${environment.apiUrl}/order/${orderId}/assign`,updateForm)
      .pipe(catchError(this.errorHandle));
    }

    getSellerListByOrdeId(orderId:any){
      return this.http.get<any>(`${environment.apiUrl}/order/${orderId}/sellers`)
      .pipe(catchError(this.errorHandle));
    }


    gerSellersByArticleId(articleId:any){
      return this.http.get<any>(`${environment.apiUrl}/catalog/${articleId}/sellers`)
      .pipe(catchError(this.errorHandle));
    }

    getRequirementsList(rowNum:any,size:any,orderStatus:any,sortKey:any,sortOrder:any):Observable<APIState<any>>{
      return this.http.get<any>(`${environment.apiUrl}/requirement/list?rowNum=${rowNum}&size=${size}&orderStatus=${orderStatus}&sortKey=${sortKey}&sortOrder=${sortOrder}`)
      .pipe(
        map((response)=>({
          data:response,
          loading:false,
          error:null
        })),
        catchError((error:HttpErrorResponse)=>of({
          data:null,
          loading:false,
          error:error.error
        })),
        startWith({
          data:null,
          loading:true,
          error:null
        })
      )
    }

    postRequirement(requirementForm:any){
      return this.http.post(`${environment.apiUrl}/requirement`,requirementForm)
      .pipe(catchError(this.errorHandle));
     }

     patchRequirement(reqForm:any,reqId:any){
      return this.http.patch(`${environment.apiUrl}/requirement/${reqId}`,reqForm)
      .pipe(catchError(this.errorHandle));
     }

     requestCallback(callbackForm:any){
      return this.http.post(`${environment.apiUrl}/help-request/create`,callbackForm)
      .pipe(catchError(this.errorHandle));
     }

     getCatalogById(id:any){
      return this.http.get(`${environment.apiUrl}/catalog/article/${id}`)
      .pipe(catchError(this.errorHandle));
     }
     
  errorHandle(error: any) {
    let errorMessage = "";
    if (error.error.error instanceof ErrorEvent) {
      errorMessage = error.error.error;
    } else {
      errorMessage = error.error;
    }

    return throwError(() => {
      return errorMessage;
    });
  }
}
